var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseAction',{attrs:{"title":"Move playlist","closeLabel":"Done","validation":_vm.validation},on:{"close":function($event){return _vm.$emit('close')}}},[_c('p',[_vm._v("Drag the playlists to move them around.")])])}
var staticRenderFns = []

export { render, staticRenderFns }